/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutAdvanced from '../components/LayoutAdvanced.jsx';
import NavigatorAdvanced from '../components/NavigatorAdvanced.jsx';
import Map from '../components/Map.jsx';
import OptionMapSelector from '../components/OptionMapSelector.jsx';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import LocalStorage from '../service/LocalStorage';

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

import IMG_CARTOGRAFIA_1 from '../img/Carousel/Cartografia/img153.jpg';
import IMG_CARTOGRAFIA_2 from '../img/Carousel/Cartografia/img91_R.jpg';

declare var M;
const plugin = new M.plugin.Mapaalacarta({
  enabled: true
});
// const xylocator = new M.plugin.XYLocator();
const ignsearch = new M.plugin.IGNSearch({
  urlFind : properties.urlGeocoder+"/api/geocoder/findJsonp",
  urlCandidates : properties.urlGeocoder+"/api/geocoder/candidatesJsonp", 
  urlReverse : properties.urlGeocoder+"/api/geocoder/reverseGeocode",
  servicesToSearch: "g",
  maxResults: 30,
  noProcess:"expendeduria"
});
const fullviewmap = new M.plugin.FullViewMap({
  position: 'BL',
});
const scaleZoomPlugin = new M.plugin.ScaleZoom(plugin);
const insertPhotoPlugin = new M.plugin.InsertPhoto({
  position: 'BL',
});
const editionTools = new M.plugin.EditionTools({numberOfDrawFeatures: 0, precharged: properties.ROUTE_CATALOGUE_URLS, minScale:properties.MINSCALE});//Movido aquí para impedir update que cause perdida de referencias a variables usadas.
// xylocator
const pluginList = [plugin, ignsearch, scaleZoomPlugin, fullviewmap, insertPhotoPlugin];

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerX: -417002.20780977904,
      centerY: 4931965.4853014955,
      isTourOpen: false,
      showModalWarningLegend: false
    };
    this.handleShowWarningLegend = this.handleShowWarningLegend.bind(this);
    this.handleCloseWarningLegend = this.handleCloseWarningLegend.bind(this);
    this.handleCloseWarningLegendContinue = this.handleCloseWarningLegendContinue.bind(this);
    window.showWarningLegend = this.handleShowWarningLegend;

    this.props.parentState.seleccionadoProductoSeries = 'Elaborado';
    //TestAdminUSER
    let testLogin = LocalStorage.get('login-cookie');// POSIBLEMENTE ES MEJOR MOVERLO FUERA DE AQUí con otro metodo de saber su estado antes de llegar aquí
    if(testLogin && testLogin.fecha > new Date().getTime()){
      this.props.parentState.specialMapGeneration = (testLogin.token === properties.TOKEN);
      this.props.parentState.author = 'CNIG';
    }else{
      LocalStorage.delete('login-cookie');
      this.props.parentState.specialMapGeneration = false;
      delete this.props.parentState.nipo;
      delete this.props.parentState.isbn;
      delete this.props.parentState.depositoLegal;
      delete this.props.parentState.codigoBarras;
      delete this.props.parentState.realCodigoBarras;
      delete this.props.parentState.specialFileName;
    }
    testLogin = null;
    //TestAdminUSER
  }

  setStateGlobal = (state) => {
    const {setParentState} = this.props;
    setParentState(state);
  }

  setModal = (mapa, state) => {
    const {setModal} = this.props;
    setModal(mapa, state);
  }

  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  setMapa = (map) => {
    let {parentState} = this.props;
    parentState.mapa = map;
    this.setStateGlobal(parentState);
  };

  convertScaleValueToScaleFactor(scaleValue) {
    var scaleFactor = 0;
    switch (scaleValue) {
      case '1:2.500':
        scaleFactor = 2.5;
        break;
      case '1:5.000':
        scaleFactor = 5;
        break;
      case '1:10.000':
        scaleFactor = 10;
        break;
      case '1:25.000':
        scaleFactor = 25;
        break;
      case '1:30.000':
        scaleFactor = 30;
        break;
      case '1:20.000':
        scaleFactor = 20;
        break;
      case '1:40.000':
        scaleFactor = 40;
        break;
      case '1:50.000':
        scaleFactor = 50;
        break;
      case '1:60.000':
        scaleFactor = 60;
        break;
      default:
        scaleFactor = 2.5;
    }

    return scaleFactor;
  }

  setScaleValue = (event) => {
    let {parentState} = this.props;
    parentState.scale = event;
    this.setStateGlobal(parentState);
    switch (event) {
      case '1:2.500':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '2.5K';
        parentState.scaleCm = '25 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 2.5);
        parentState.previousScale = event;
        parentState.zoom = 15;
        break;
      case '1:5.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '5K';
        parentState.scaleCm = '50 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 5);
        parentState.previousScale = event;
        parentState.zoom = 14;
        break;
      case '1:10.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '10K';
        parentState.scaleCm = '100 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 10);
        parentState.previousScale = event;
        parentState.zoom = 13;
        break;
      case '1:25.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '25K';
        parentState.scaleCm = '250 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 25);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
      case '1:30.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '30K';
        parentState.scaleCm = '300 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 30);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      case '1:20.000':
        parentState.activeRow = 'firstRow';
        parentState.selectedRow = '20K';
        parentState.scaleCm = '200 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 20);
        parentState.previousScale = event;
        parentState.zoom = 12;
        break;
      case '1:50.000':
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '50K';
        parentState.scaleCm = '500 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 50);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      case '1:40.000':
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '40K';
        parentState.scaleCm = '400 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 40);
        parentState.previousScale = event;
        parentState.zoom = 11;
        break;
      default:
        parentState.activeRow = 'secondRow';
        parentState.selectedRow = '60K';
        parentState.scaleCm = '600 m)';
        plugin.scaleMap(this.convertScaleValueToScaleFactor(parentState.previousScale), 60);
        parentState.previousScale = event;
        parentState.zoom = 10;
        break;
    }

    this.setStateGlobal(parentState);
    if(window.mapJs.getZoom()<parentState.zoom){
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);//plugin.setMapCenter(parentState.mapa);
    }

    // actualizar escala del plugin insertPhoto
    const scaleDenominator = parseFloat(event.replace('1:', '').replace('.', ''));
    insertPhotoPlugin.updateScale(scaleDenominator);

    return parentState.scale;
  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  setOrientation = (event) => {
    let {parentState} = this.props;
    if (parentState.previousOrientation !== parentState.orientation) {
      plugin.rotate(event);
      plugin.setMapCenterZoom(parentState.mapa, parentState.zoom);
      parentState.orientation = event;
      if(parentState.verticalCartela){
        if(parentState.image.endsWith(".jpg")){
          parentState.image_preview= IMG_CARTOGRAFIA_2;
          parentState.image= IMG_CARTOGRAFIA_2;
          parentState.imageName = 'img91_R.jpg';
        }
      }else{
        if(parentState.image.endsWith(".jpg")){
          parentState.image_preview= IMG_CARTOGRAFIA_1;
          parentState.image= IMG_CARTOGRAFIA_1;
          parentState.imageName = 'img91.jpg';
        }
      }
      //this.setStateGlobal(parentState);
    }
    this.setStateGlobal(parentState);
  }

  setVertical = (state) =>{
    let {parentState} = this.props;
    if(state){
      if(parentState.image.endsWith(".jpg")){
        parentState.image_preview= IMG_CARTOGRAFIA_2;
        parentState.image= IMG_CARTOGRAFIA_2;
        parentState.imageName = 'img91_R.jpg';
      }
      /*if(!parentState.imageName.endsWith('_R.jpg') && parentState.imageName !== 'custom'){
        let imageName = parentState.imageName.split('.');
        imageName = imageName[0] + (parentState.orientation === 'Retrato' && parentState.active < 6?'_R.':'.') + imageName[imageName.length - 1];
        parentState.imageName = imageName;
      }*/
    }else{
      if(parentState.image.endsWith(".jpg")){
        parentState.image_preview= IMG_CARTOGRAFIA_1;
        parentState.image= IMG_CARTOGRAFIA_1;
        parentState.imageName = 'img91.jpg';
      }
      /*if(parentState.imageName.endsWith('_R.jpg')){//6 length ending
        parentState.imageName = parentState.imageName.substr(0,parentState.imageName.length-6)+'.jpg';
      }*/
    }
    this.setStateGlobal(parentState);
  }

  handleShowWarningLegend() {
    this.props.parentState.numberId = editionTools.getNumberOfIdFeature();//update del numberId
    this.setState({showModalWarningLegend: true});
  }
  handleCloseWarningLegend() {
    this.setState({showModalWarningLegend: false});
    const drawLegend = document.querySelector('div.m-control.m-addlegend-container');
    if (drawLegend.classList.contains('activated')) {
      drawLegend.children[0].click();
    }
  }
  handleCloseWarningLegendContinue(){
    this.setState({showModalWarningLegend: false});
    editionTools.toggleLegendMenu();
  }
  componentWillUnmount(){
    window.showWarningLegend = null;
  }

  render() {
    const {centerX, centerY, isTourOpen} = this.state;
    const {parentState} = this.props;

    const steps = [
      {
        selector: '.first-step',
        content: i18n.t('tour.step1FirstStep'),
      },
      {
        selector: '.showGridHelp',
        content: i18n.t('tour.mapHelpStep1'),
      },
      {
        selector: '.second-step',
        content: i18n.t('tour.step1SecondStep'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      },
      {
        selector: '.third-step',
        content: i18n.t('tour.step1ThirdStep'),
      },
      {
        selector: '.cartela-step',
        content: i18n.t('tour.cartelaStep1'),
      },
      {
        selector: '.fourth-step',
        content: i18n.t('tour.step1FourthStep'),
      },
      {
        selector: '.fifth-step',
        content: i18n.t('tour.step1FifthStep'),
      },
      {
        selector: '.search-panel',
        content: i18n.t('tour.step1SixthStep'),
      },
      {
        selector: '.m-xylocator',
        content: i18n.t('tour.step1SeventhStep'),
      },
      {
        selector: '.m-scalezoom',
        content: i18n.t('tour.step1TenthStep'),
      },
      {
        selector: '#container-button2',
        content: i18n.t('tour.step1EleventhStep'),
      },
      {
        selector: '.m-plugin-fullviewmap',
        content: i18n.t('tour.step1EighthStep'),
      },
      {
        selector: '#m-insertPhoto-btn',
        content: i18n.t('tour.step1TwelveStep'),
      },
      {
        selector: '.m-tools-editionTools',
        content: i18n.t('tour.step1NinthStep'),
      },
      {
        selector: '#m-button-drawFeature',
        content: i18n.t('tour.step1NinthPointTwoStep'),
      },
      {
        selector: '#m-button-drawFeature2',
        content: i18n.t('tour.step1NinthPointThreeStep'),
      },
      {
        selector: '#m-button-drawFeature3',
        content: i18n.t('tour.step1NinthPointFourStep'),
      },
      {
        selector: '#m-button-drawFeature5',
        content: i18n.t('tour.step1NinthPointFiveStep'),
      },
      {
        selector: '#m-button-addprecharged',
        content: i18n.t('tour.step1NinthPointNineStep'),
      },
      {
        selector: '#m-button-locallayers',
        content: i18n.t('tour.step1NinthPointOneStep'),
      },
      {
        selector: '#m-button-addlegend',
        content: i18n.t('tour.step1AddLegend'),
      },
      {
        selector: '#m-button-pickfeature',
        content: i18n.t('tour.step1NinthPointFiveTwoStep'),
      },
      {
        selector: '#m-button-moveFeature',
        content: i18n.t('tour.step1NinthPointSixStep'),
      },
      {
        selector: '#m-button-editFeature',
        content: i18n.t('tour.step1NinthPointSevenStep'),
      },
      {
        selector: '#m-button-deleteFeature',
        content: i18n.t('tour.step1NinthPointEightStep'),
      },
      {
        selector: '#m-button-downloadLayer',
        content: i18n.t('tour.step1NinthPointTenStep'),
      },
      {
        selector: '#m-button-undoFeature',
        content: i18n.t('tour.step1NinthPointElevenStep'),
      }
    ]

    editionTools.setNumberOfIdFeature(parentState.numberId);
    scaleZoomPlugin.setState(parentState);
    scaleZoomPlugin.setCallbackState(this.setStateGlobal);

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar';
    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = 'step1'
    const sectionClassName = 's1-left';
    const asideClassName = 's1-right';

    //Next and previous pages
    const nextPage = '/Step2';
    const previousPage = '/main';

    return (<React.Fragment>
      <LayoutAdvanced setParentStateSteps={this.setStateGlobalStep} parentState={parentState} inforCoords={parentState.inforFeatureCoordinates[0]} label={null} activeRow={this.props.activeRow} nextPage={nextPage} previousPage={previousPage} isStep3={0}>
        <Dialog open={this.state.showModalWarningLegend} onClose={this.handleCloseWarningLegend} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.generateLegend">
              Generar leyenda
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.generateLegendWarning">
              Se recomienda configurar la leyenda solo tras finalizar el añadido y estilado de todas las demás entidades del mapa.
            </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWarningLegendContinue}>
              <Trans i18nKey="dialog.continue">CONTINUAR</Trans>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWarningLegend}>
              <Trans i18nKey="dialog.cancel">CANCELAR</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <NavigatorAdvanced leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorAdvanced>
        <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={this.closeTour} />
        <h1>
          <i className="mc-design"></i>
          <label>
          <Trans i18nKey="step1.mapDesign">
            Diseño del mapa
          </Trans>
          </label>
        </h1>
        <div className={stepClassName}>
          <section className={sectionClassName}>
            <div className="fifth-step">
              <Map setModal={this.setModal} setParentState={this.setStateGlobal} location={this.props.location} pluginEdition={editionTools} parentState={parentState} pluginList={pluginList} M={M} centerX={centerX} centerY={centerY} mapa={this.setMapa} isSimple={false}></Map>
            </div>
            <br/>
            <a onClick={this.openTour}>
              <label id="download-tui-image" className="inputfile generalHelpButton">
                <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
              </label>
            </a>
          </section>
          <OptionMapSelector setParentState={this.setStateGlobal} parentState={parentState} actionScale={this.setScaleValue} actionOrientation={this.setOrientation} actionVertical={this.setVertical} scaleValueChild={parentState.scale} activeRow={this.props.activeRow} asideClassName={asideClassName} classPanelButton='panel-button' classPanelContent='panel-content' pluginEdition={editionTools}/>
        </div>
      </LayoutAdvanced>
    </React.Fragment>);
  }
}

export default Step1;
